"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Unknown"] = 0] = "Unknown";
    AccountType[AccountType["Schools"] = 1] = "Schools";
    AccountType[AccountType["PWS"] = 2] = "PWS";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
//# sourceMappingURL=AccountType.js.map